import { InteractionMetric } from "@edgetier/watchtower-types";

// Where no metric is found in the URL, use this.
export const DEFAULT_METRIC = InteractionMetric.HandlingTime;
